import { FC } from 'react';
import styles from './ContractBonuses.module.scss';
import { Layout } from '../../shared/ui/Layout';
import { prize } from '../../assets';
import {Rewards} from "../../entities/bonuses/ui/Rewards/Rewards.tsx";
import {useTranslation} from "react-i18next";

const ContractBonuses: FC = () => {
    const {t} = useTranslation()
    return (
        <Layout
            bgColor1="rgba(61, 25, 164, 1)"
            bgColor2="rgba(88, 29, 186, 1)"
            bgColor3="rgba(183, 112, 255, 1)"
            bgColor4="rgba(175, 137, 255, 1)"
            bgColor5="rgba(193, 177, 255, 1)"
            icon={prize}
            title={t('bonus_title')}>
            <div className={styles.ContractBonuses}>
                <Rewards />
            </div>
        </Layout>
    );
};

export default ContractBonuses;
